import React from 'react';
import './Rim-card.css';
import rimData from "./rim-card.json"
import PropTypes from 'prop-types'; 
function CardRim(props) {
  const { widgetName, component, applystyle, applyScroll} = props;

  return (
    
    <div className={(widgetName === rimData.widgetName['LOGIN ACTIVITY'] || widgetName === rimData.widgetName['CONFIGURATION CHANGE EVENTS']) ? 'chart-card-3-rim' : 'rim-chart-card-3'}>


      <div className='rim-chart-header-3'>
        <div className='rim-chart-title-3'>
          {widgetName}
        </div>
      
      </div>
      <hr />
      
      {applyScroll ? <div className="rim-card-content-3 rim-card-content-scroll-3" >
        {component}
      </div> :
        <div className={applystyle ? 'rim-card-content-3 rim-card-content-even-align-3' : 'rim-card-content-3'} >
          {component}
        </div>
      }
    </div>
  );
}


// Add prop validation
CardRim.propTypes = {
  widgetName: PropTypes.string.isRequired, 
  component: PropTypes.node.isRequired,   
  applystyle: PropTypes.bool,            
  applyScroll: PropTypes.bool           
};

export default CardRim;


